import { FiPauseCircle, FiPlayCircle, FiRotateCcw, FiRotateCw } from "react-icons/fi";
import { BsPlayFill } from "react-icons/bs";
import { IoStopCircleOutline } from "react-icons/io5";
import { styled } from "styled-components";
import { FaCircle } from "react-icons/fa6";
import { useCallback, useEffect, useState } from "react";

interface PlayerControlsProps {
    handlePlayPause: (status: boolean) => void;
    playing: boolean;
    handleSeekChange: (value: number) => void;
    hideSeek?: boolean;
    size?: number;
}
  
const ControlsContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const PauseButton = styled(FiPauseCircle)<{ishovered?: boolean}>`
    transition: opacity 1.5s ease-in-out;
    opacity: ${({ ishovered }) => (ishovered ? 1 : 0)};
`


const ControlIcon = styled.img`
    width: 28px;
    height: 28px;
    cursor: pointer;
`;

const PlayerControls: React.FC<PlayerControlsProps> = ({ handlePlayPause, playing, handleSeekChange, hideSeek, size }) => {
  
  const [isPlaying, setIsPlaying] = useState(false);
  const [hovered, setHovered] = useState(false);
  
  const handlePausePlay =(status: boolean) => {
    setIsPlaying((prev) => !prev);
    handlePlayPause(status);
  };

  useEffect(()=>{
    setIsPlaying(playing);
  }, [playing]);


  return (
    <ControlsContainer 
      
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      {!hideSeek && <FiRotateCcw onClick={() => handleSeekChange(-10)} />}
      {isPlaying ? (
        <PauseButton ishovered={hovered} className="apply-face" onClick={() => handlePausePlay(false)} color="rgba(255, 255, 255,0.75)" cursor="pointer" size={size ? size/2: 75} />
      ) : (
        <BsPlayFill onClick={() => handlePausePlay(true)} color="rgba(255, 255, 255,0.75)" cursor="pointer" size={size ? size/2: 75} />
      )}
      {!hideSeek && <FiRotateCw onClick={() => handleSeekChange(10)} />}
    </ControlsContainer>
  )
}

  
export default PlayerControls;
  